import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { ColorRing } from 'react-loader-spinner'
import FileUpload from "./components/file-upload/file-upload-clinicalInfo.component";
import ButtonOptions from './ButtonOptions';
import PropTypes from 'prop-types';

export default function CCR({
	requestType,
	showEmergencyMessage,
	handleRequestTypeChange,
}) {


	const [submitIntakeResult, setSubmitIntakeResult] = useState(null);
	const [clinicalInfo, setClinicalInfo] = useState({ docs: [] });
	const [spinner, setSpinner] = useState(false);


	const [authNumber, setAuthNumber] = useState('');
	const [patientFirstName, setPatientFirstName] = useState('');
	const [patientLastName, setPatientLastName] = useState('');
	const [dos, setDOS] = useState('');



	const updateUploadedFiles = (files) => setClinicalInfo({ ...clinicalInfo, docs: files });

	const handleSubmit = async (e) => {
		e.preventDefault();

		setSpinner(true);
		var formData = new FormData();
		for (var i = 0; i < clinicalInfo.docs.length; i++) {
			formData.append("files", clinicalInfo.docs[i]);
		}


		const data = JSON.stringify({
			authNumber: authNumber,
			patientFirstName: patientFirstName,
			patientLastName: patientLastName,
			dos: dos,

		});

		formData.append("formInfo", data);

		const requestOptions = {
			method: 'POST',
			body: formData
		};

		try {

			const res = await fetch('https://veritasallies.net/opensearch/ccr', requestOptions);
			setSpinner(false);

			if (!res.ok) {
				const message = `An error has occured: ${res.status} - ${res.statusText}`;
				throw new Error(message);
			}

			const r = await res.text();

			const result = {
				status: res.status + "-" + res.statusText,
				headers: {
					"Content-Type": res.headers.get("Content-Type"),
					"Content-Length": res.headers.get("Content-Length"),
				},
				data: r
			};

			setSubmitIntakeResult(result.data);
		} catch (err) {
			setSubmitIntakeResult(err.message);
			setSpinner(false);
		}
	};

	const handleAuthNumberChange = (event) => {
		setAuthNumber(event.target.value);
	};
	const handlePatientFirstNameChange = (event) => {
		setPatientFirstName(event.target.value);
	};
	const handlePatientLastNameChange = (event) => {
		setPatientLastName(event.target.value);
	};
	const handleDOSChange = (event) => {
		setDOS(event.target.value);
	};



	return (
		<div sx={{ justifyContent: "center" }}>
			{submitIntakeResult && <div className="alert alert-secondary mt-2" role="alert"><h2>{submitIntakeResult}</h2></div>}
			{!submitIntakeResult && (
				<form onSubmit={handleSubmit}>
					<Stack spacing={2} direction="column" sx={{ margin: 'auto', width: '50%' }}>
						<div>
							<h2> Concurrent Review </h2>
						</div>
						<ButtonOptions
							requestType={requestType}
							showEmergencyMessage={showEmergencyMessage}
							handleRequestTypeChange={handleRequestTypeChange}
						/>
						<TextField id="outlined-basic" label="Authorization #" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							onChange={handleAuthNumberChange}
							required
						/>
						<TextField id="outlined-basic" label="Patient First Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							onChange={handlePatientFirstNameChange}
						/>
						<TextField id="outlined-basic" label="Patient Last  Name" variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							onChange={handlePatientLastNameChange}
						/>
						<TextField
							id="dateOfService"
							label="Date of Service for Concurrent Review"
							type="date"

							InputLabelProps={{
								shrink: true,
							}}
							onChange={handleDOSChange}
							required
						/>

						<FileUpload
							accept=".pdf,image/*"
							label="Upload Clinical Information"
							multiple
							updateFilesCb={updateUploadedFiles}
						/>
					</Stack>
					<Stack spacing={2} direction="row" sx={{ margin: 'auto', width: '50%' }}>
						<Button variant="outlined" type="submit">Submit</Button>
						<ColorRing
							visible={spinner}
							height="80"
							width="80"
							ariaLabel="blocks-loading"
							wrapperStyle={{}}
							wrapperClass="blocks-wrapper"
							colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
						/>
					</Stack>
				</form>
			)}
		</div >
	);
}

CCR.propTypes = {
	requestType: PropTypes.string,
	showEmergencyMessage: PropTypes.func,
	handleRequestTypeChange: PropTypes.func,
};